export const SET_ROLE_LIST = "SET_ROLE_LIST";
export const SET_AUTHORIZATION_LIST = "SET_AUTHORIZATION_LIST";
export const SET_AUTHORIZED_PAGES = "SET_AUTHORIZED_PAGES";
export const SET_USER_LIST = "SET_USER_LIST";
export const SET_PAGE_ROUTE = "SET_PAGE_ROUTE";
export const SET_CUSTOMER_LIST = "SET_CUSTOMER_LIST";
export const SET_USER_DATA_LIST = "SET_USER_DATA_LIST";
export const SETEMAILCREDENTIALLIST = "SETEMAILCREDENTIALLIST";
export const SETEMAILCONTENTLIST = "SETEMAILCONTENTLIST";
export const SETSERVICECALLORIGINLIST = "SETSERVICECALLORIGINLIST";
export const SETQUICKCREATESETTING = "SETQUICKCREATESETTING";